import api from '@/services/Api';

class Nominations {
  static create(awardId, payload) {
    return api.post(`/awards/awards/${awardId}/nominations`, payload);
  }

  static all() {
    return api.get('/awards/nominations');
  }

  static get(id) {
    return api.get(`/awards/nominations/${id}`);
  }

  static update(id, payload) {
    return api.put(`/awards/nominations/${id}`, payload);
  }

  static delete(id) {
    return api.delete(`/awards/nominations/${id}`);
  }
}

export default Nominations;
